import { render, staticRenderFns } from "./RulesAgree.vue?vue&type=template&id=2981d55b"
import script from "./RulesAgree.vue?vue&type=script&lang=ts"
export * from "./RulesAgree.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseBtn: require('/builds/medtochka/medtochka-frontend/core/components/Base/BaseBtn.vue').default,BaseContainer: require('/builds/medtochka/medtochka-frontend/core/components/Base/BaseContainer.vue').default})
